<template>
    <rkm-area title="Procedimento">
        <Form
            :additionals="additionals"
            :cid="cid"
            :form="form"
            :model="model"
        />
    </rkm-area>
</template>

<script>
import Form from './Form'

export default {
    components: { Form },
    props: {
        additionals: { type: Object, required: true },
        cid: { type: Object },
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    }
}
</script>